import React, { FC } from 'react';
import renderWithHighlight from '../RenderHighlight';

const AssetIdDisplay: FC<any> = ({ asset, highlight }): React.ReactElement => {
	const idKey = asset.buyerSpecificAssetId ? 'buyerSpecificAssetId' : 'id';
	const idValue = asset.buyerSpecificAssetId || asset.id;
	return (
		<div className="flex text-gray-500">
			<div className="mr-4">
				Asset ID {renderWithHighlight(highlight, idKey, idValue, false, 'highlights')}
			</div>
			{asset.serialNumber ? (
				<div className="mr-4">
					Serial Number{' '}
					{renderWithHighlight(highlight, 'serialNumber', asset.serialNumber, false, 'highlights')}
				</div>
			) : null}
		</div>
	);
};

export default AssetIdDisplay;
